// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hi","advertCardNum":"c-a_hj"};